// extracted by mini-css-extract-plugin
export default {"root__title":"style-module__root__title___hCLLE","root__list":"style-module__root__list___QTNWF","root__list_text":"style-module__root__list_text___fW_ZO","root__list_item":"style-module__root__list_item___zf6lt","root__list_btn":"style-module__root__list_btn___ahanu"};
    if(module.hot) {
      // 1697460476252
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  